import { render, staticRenderFns } from "./FileUploadedInfo.vue?vue&type=template&id=6527368b"
import script from "./FileUploadedInfo.vue?vue&type=script&lang=js"
export * from "./FileUploadedInfo.vue?vue&type=script&lang=js"
import style0 from "./FileUploadedInfo.vue?vue&type=style&index=0&id=6527368b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports